// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"69afec3a","981":"3b01fe83"}[chunkId] + ".chunk.js";
};